import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { eventTypeSelector, isPersonalEventTypeSelector } from '../../selectors';
import { FlexContainer } from '../styles';
import { Invitation } from './invitation';
import { Membership } from './membership';
const listItemCss = "l144shwp";
const ListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(listItemCss, props.className)} />;
});
const ParticipantData = ({
  participant,
  canRemove,
  onRemove
}) => {
  switch (participant.type) {
    case 'organization_membership':
      return <Membership membership={participant.entity} canRemove={canRemove} onRemove={onRemove} />;
    case 'organization_invitation':
    case 'user_consolidation':
      return <Invitation invitation={participant.entity} canRemove={canRemove} onRemove={onRemove} />;
    default:
      return null;
  }
};
export const Participant = ({
  participant,
  canRemove,
  onRemove
}) => {
  const {
    profile
  } = useSelector(eventTypeSelector);
  const isPersonalEventType = useSelector(isPersonalEventTypeSelector);
  const isPersonalEventTypeHost = isPersonalEventType && participant.entity.user_id === profile.owner_id;
  const canRemoveParticipant = !isPersonalEventTypeHost && canRemove;
  const handleRemove = () => {
    if (participant.type === 'organization_membership' && !canRemoveParticipant) return;
    onRemove(participant);
  };
  return <ListItem data-testid={isPersonalEventTypeHost ? 'event-type-host' : null}>
      <FlexContainer>
        <ParticipantData participant={participant} canRemove={canRemoveParticipant} onRemove={handleRemove} />
      </FlexContainer>
    </ListItem>;
};

require("./participant.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./participant.js");